/*
 * Copyright © HatioLab Inc. All rights reserved.
 */
import { ComponentNature, RectPath, Shape, sceneComponent, RealObject, MaterialBank } from '@hatiolab/things-scene'
import * as THREE from 'three'

const NATURE: ComponentNature = {
  mutable: false,
  resizable: true,
  rotatable: true,
  properties: [
    {
      type: 'color',
      label: 'leg-color',
      name: 'legColor',
      property: 'legColor'
    }
  ],
  help: 'scene/component/desk'
}

export class Desk3D extends RealObject {
  get boardThickness() {
    var { depth } = this.component.state

    return Math.min(10, depth / 10)
  }

  get legThickness() {
    var { width, height } = this.component.state

    var min = Math.min(width, height)

    return Math.min(10, min / 10)
  }

  get margin() {
    return Math.min(this.legThickness / 5, 2)
  }

  build() {
    super.build()

    var { width, height, depth } = this.component.state

    var top = (depth - this.boardThickness) / 2

    var legs = this.createDeskLegs(width, height, depth)
    legs.position.set(0, -this.boardThickness / 2, 0)
    legs.castShadow = true

    this.object3d.add(legs)

    let board = this.createDeskBoard(width, height)
    board.position.set(0, top, 0)
    board.rotation.x = Math.PI / 2
    board.castShadow = true

    this.object3d.add(board)
  }

  createDeskLegs(w: number, h: number, d: number) {
    var { legColor } = this.component.state

    var legThickness = this.legThickness
    var margin = this.margin
    d -= this.boardThickness

    var legs = new THREE.Group()

    var posX = w / 2 - legThickness / 2 - margin
    var posY = h / 2 - legThickness / 2 - margin
    var posZ = 0

    for (var i = 0; i < 4; i++) {
      var geometry = new THREE.BoxGeometry(legThickness, d, legThickness)
      var material = MaterialBank.material('desk|leg', {}, legColor || '#252525')

      var leg = new THREE.Mesh(geometry, material)
      leg.castShadow = true

      switch (i) {
        case 0:
          leg.position.set(posX, posZ, posY)
          break
        case 1:
          leg.position.set(posX, posZ, -posY)
          break
        case 2:
          leg.position.set(-posX, posZ, posY)
          break
        case 3:
          leg.position.set(-posX, posZ, -posY)
          break
      }

      legs.add(leg)
    }

    return legs
  }

  createDeskBoard(w: number, h: number) {
    var { fillStyle } = this.component.state

    var d = 10

    var boardMaterial = MaterialBank.material('desk|board', {}, fillStyle || '#ccaa76')
    var boardGeometry = new THREE.BoxGeometry(w, h, d, 1, 1)
    var board = new THREE.Mesh(boardGeometry, boardMaterial)

    return board
  }
}

@sceneComponent('desk')
export class Desk extends RectPath(Shape) {
  buildRealObject(): RealObject | undefined {
    return new Desk3D(this)
  }

  get nature() {
    return NATURE
  }
}
